.cx{aspect-ratio:1/1;}